<app-clip-text-box [sessionView]="sessionView"></app-clip-text-box>
<a target="_blank" href=javascript:void(0) id=printDownloadLink tabindex=-1 aria-hidden=true></a>
<div class="main-container flex-row align-start-stretch" style="background: transparent;">
  <div class="fuse-navy-900 app-sidebar flex-col align-start-stretch">
    <div class="remote-app-hover remote-app-icon-bg" id="session-view-go-home" (click)="goToHome()">
      <mat-icon class="arrow-back-icon">arrow_back</mat-icon>
    </div>
    @if (loading) {
      <mat-progress-spinner diameter="27" mode="indeterminate" color="accent" class="progress-spinner"></mat-progress-spinner>
    } @else {
      <div class="apps-drawer flex-col align-center-center" (click)="openAppDrawer()">
        <mat-icon [inline]="true">apps</mat-icon>
      </div>
    }

    @for (item of getSessionsStore() | keyvalue; track item) {
      @if (item.value && item.value.sessionList) {
        @if (item.value.sessionList.length === 1) {
          <app-session-single
            [grouped]="false"
            [session]="item.value.sessionList[0]"
            [activeSession]="activeSessionId()"
          (sessionClick)="onSessionClick($event)"></app-session-single>
        } @else {
          <app-session-grouped
            (sessionClick)="onSessionClick($event)"
            [activeSession]="activeSessionId()"
            [sessionGroup]="item.value">
          </app-session-grouped>
        }
        <ng-template #grouped>
          <app-session-grouped
            (sessionClick)="onSessionClick($event)"
            [activeSession]="activeSessionId()"
            [sessionGroup]="item.value">
          </app-session-grouped>
        </ng-template>
      }
    }

    @if (isFullscreen()) {
      <div class="remote-app-hover remote-app-icon-bg fullscreen-button" (click)="exitFullscreen()">
        <mat-icon class="arrow-back-icon">fullscreen_exit</mat-icon>
      </div>
    } @else {
      <div class="remote-app-hover remote-app-icon-bg fullscreen-button" (click)="goFullscreen()">
        <mat-icon class="arrow-back-icon">fullscreen</mat-icon>
      </div>
    }
    @if (!isGuacActive()) {
      <div class="remote-app-hover remote-app-icon-bg virtual-keyboard-toggle"
           [class.vk-active]="virtualKeyboardVisible()"
           matTooltip="Teclado virtual"
           matTooltipPosition="right"
           (click)="toggleVirtualKeyboard()">
        <mat-icon class="arrow-back-icon">keyboard</mat-icon>
      </div>
    }
    @if (showR2CloudRobot) {
      <img class="logo-icon" src="assets/images/logos/r2/medium/r2-cloud-robo-medium.png">
    }
  </div>
  <div class="flex-1 flex-col align-center-center" class=canvas-container id=canvas-container>

  </div>
  @if (virtualKeyboardVisible() && !isGuacActive()) {
    <app-virtual-keyboard [sessionView]="sessionView" (closed)="toggleVirtualKeyboard()"></app-virtual-keyboard>
  }
</div>